import { useEffect, useState } from "react";

const BACKEND = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

let _cache = null; // true = visible, false = hidden
let _promise = null;

async function _fetch() {
  const bases = [BACKEND, typeof window !== "undefined" ? window.location.origin : "", "https://bob-website-api.onrender.com"]
    .filter((b, i, arr) => b && arr.indexOf(b) === i);
  for (const base of bases) {
    try {
      const r = await fetch(`${base}/api/shipping-only-config`, { cache: "no-store" });
      if (!r.ok) continue;
      const ct = (r.headers.get("content-type") || "").toLowerCase();
      if (!ct.includes("application/json")) continue;
      const data = await r.json();
      // Missing flag = hidden. Only an explicit false shows the page.
      return data.page_hidden === false;
    } catch (_) { /* try next */ }
  }
  return false;
}

function getVisibility() {
  if (_cache !== null) return Promise.resolve(_cache);
  if (!_promise) {
    _promise = _fetch()
      .then((v) => { _cache = v; return v; })
      .catch(() => { _cache = false; return false; });
  }
  return _promise;
}

export function invalidateShippingOnlyCache() {
  _cache = null;
  _promise = null;
}

export function useShippingOnlyVisibility() {
  const [visible, setVisible] = useState(_cache === true);
  const [ready, setReady] = useState(_cache !== null);

  useEffect(() => {
    let cancelled = false;
    getVisibility().then((v) => {
      if (cancelled) return;
      setVisible(v);
      setReady(true);
    });
    return () => { cancelled = true; };
  }, []);

  return { visible, ready };
}

export function useShippingOnlyVisible() {
  const { visible, ready } = useShippingOnlyVisibility();
  // Stay hidden until the API answers so the nav cannot flash the link.
  return ready && visible;
}
